import { render, staticRenderFns } from "./ManageDeliveryEndView.vue?vue&type=template&id=b3e63dc2"
import script from "./ManageDeliveryEndView.vue?vue&type=script&lang=ts"
export * from "./ManageDeliveryEndView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports